export const SERVICE_TYPES = {
  ATELIER: 'atelier',
  MAINTENANCE: 'maintenance',
  MENAGE: 'menage',
  JARDIN: 'jardin',
  INFORMATIQUE: 'informatique',
  PLOMBERIE: 'plomberie',
  ELECTRICITE: 'electricite',
  CLIMATISATION: 'climatisation',
  PEINTURE: 'peinture',
  MENUISERIE: 'menuiserie',
  SERRURERIE: 'serrurerie',
  MACONNERIE: 'maconnerie',
  SECURITE: 'securite',
  AUTRE: 'autre'
};

export const SERVICE_ROLES = {
  TECHNICAL: 'technical',
  REQUESTER: 'requester'
};

export const SCHOOL_TYPES = {
  LYCEE: 'lycee',
  COLLEGE: 'college',
  ECOLE: 'ecole'
};

export const serviceColors = {
  [SERVICE_TYPES.ATELIER]: '#FF6B6B',      // Rouge clair
  [SERVICE_TYPES.MAINTENANCE]: '#4ECDC4',   // Turquoise
  [SERVICE_TYPES.MENAGE]: '#45B7AF',       // Vert
  [SERVICE_TYPES.JARDIN]: '#96CEB4',       // Vert clair
  [SERVICE_TYPES.INFORMATIQUE]: '#FFEEAD',  // Jaune clair
  [SERVICE_TYPES.PLOMBERIE]: '#87CEEB',     // Bleu ciel
  [SERVICE_TYPES.ELECTRICITE]: '#FFB347',   // Orange
  [SERVICE_TYPES.CLIMATISATION]: '#98FB98',  // Vert pâle
  [SERVICE_TYPES.PEINTURE]: '#DDA0DD',      // Violet clair
  [SERVICE_TYPES.MENUISERIE]: '#F0E68C',    // Kaki clair
  [SERVICE_TYPES.SERRURERIE]: '#B8860B',    // Or foncé
  [SERVICE_TYPES.MACONNERIE]: '#BC8F8F',    // Brun rosé
  [SERVICE_TYPES.SECURITE]: '#CD5C5C',      // Rouge indien
  [SERVICE_TYPES.AUTRE]: '#D4D4D4'         // Gris
};

export const serviceRoleLabels = {
  [SERVICE_ROLES.TECHNICAL]: 'Service technique',
  [SERVICE_ROLES.REQUESTER]: 'Service demandeur'
};

export const serviceTypeLabels = {
  [SERVICE_TYPES.ATELIER]: 'Atelier',
  [SERVICE_TYPES.MAINTENANCE]: 'Maintenance',
  [SERVICE_TYPES.MENAGE]: 'Ménage',
  [SERVICE_TYPES.JARDIN]: 'Jardin',
  [SERVICE_TYPES.INFORMATIQUE]: 'Informatique',
  [SERVICE_TYPES.PLOMBERIE]: 'Plomberie',
  [SERVICE_TYPES.ELECTRICITE]: 'Électricité',
  [SERVICE_TYPES.CLIMATISATION]: 'Climatisation',
  [SERVICE_TYPES.PEINTURE]: 'Peinture',
  [SERVICE_TYPES.MENUISERIE]: 'Menuiserie',
  [SERVICE_TYPES.SERRURERIE]: 'Serrurerie',
  [SERVICE_TYPES.MACONNERIE]: 'Maçonnerie',
  [SERVICE_TYPES.SECURITE]: 'Sécurité',
  [SERVICE_TYPES.AUTRE]: 'Autre'
};

export const schoolTypeLabels = {
  [SCHOOL_TYPES.LYCEE]: 'Lycée',
  [SCHOOL_TYPES.COLLEGE]: 'Collège',
  [SCHOOL_TYPES.ECOLE]: 'École'
};
